import { MAPS_DIRECTIONS_URL } from "@/config/maps";

/** Canonical production domain — must match live site and Search Console property. */
export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, "") ||
  "https://cargaragevag.com";

export const SITE_NAME = "Car Garage VAG";
export const SITE_BRAND = "cargaragevag";
export const SITE_ALTERNATE_NAMES = [
  "Car Garage",
  "Car Garage VAG",
  "cargaragevag",
  "Cargo Garage VAG",
  "Car Garage Volkswagen Servis",
] as const;

export const DEFAULT_LOCALE = "tr_TR";
export const DEFAULT_TITLE = "Car Garage VAG";
export const TITLE_TEMPLATE = "%s | Car Garage VAG";
export const DEFAULT_DESCRIPTION =
  "Car Garage VAG (cargaragevag), Pendik İstanbul'da Volkswagen, Audi, SEAT, Škoda, Porsche ve Cupra araçlara özel servis sunar. DSG şanzıman, arıza tespit, periyodik bakım ve Kinergo distribütörlüğü.";
export const DEFAULT_KEYWORDS = [
  "cargaragevag",
  "car garage vag",
  "car garage",
  "volkswagen özel servis",
  "vag servis istanbul",
  "vag servis pendik",
  "dsg şanzıman servisi",
  "audi servis pendik",
  "seat servis istanbul",
  "skoda servis pendik",
  "kinergo türkiye",
].join(", ");

export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/card.png`;

export const SOCIAL_PROFILES = {
  instagram: "https://www.instagram.com/cargaragevag/",
  whatsapp: "https://wa.me/905373899090",
  maps: MAPS_DIRECTIONS_URL,
} as const;

export const COMPANY = {
  name: SITE_NAME,
  legalName: "Car Garage VAG",
  phone: "+90 537 389 90 90",
  altPhone: "+90 216 441 99 11",
  email: "servis@cargarage.tr",
  addressStreet: "Yeşilbağlar Mah. Azim Sok. No:11",
  addressLocality: "Pendik",
  postalCode: "34893",
  addressRegion: "İstanbul",
  addressCountry: "TR",
  geo: {
    latitude: 40.8765,
    longitude: 29.2334,
  },
};

export function toAbsoluteUrl(pathname: string): string {
  if (!pathname) return SITE_URL;
  if (pathname.startsWith("http")) return pathname;
  const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${SITE_URL}${normalized}`;
}
